module.exports = __webpack_public_path__ + "img/css3-alt.ac2bf97c.svg";